var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronClosedDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3px",
    height: "4px",
    viewBox: "0 0 3 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D4CB76FF-09F9-4C6C-9638-11C79063D660") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overview-&-Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Analytics-[Routines]---GMS",
    transform: "translate(-181.000000, -183.000000)",
    fill: "#878787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rutinas-Tabla-v3",
    transform: "translate(154.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(16.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "drop",
    transform: "translate(12.666667, 35.000000) rotate(90.000000) translate(-12.666667, -35.000000) ",
    points: "12.6666667 34 14.3333333 36 11 36"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronClosedDown);
export default __webpack_public_path__ + "static/media/chevron-closed-down.cea7fc0d539248a691cbd820e946103e.svg";
export { ForwardRef as ReactComponent };